export const getUserSuccess = "getUserSuccess";
export const getMyProfileSuccess = "getMyProfileSuccess";
export const updateSocialaccounts = "updateSocialaccounts";

export const updateContactPrefrences = "updateContactPrefrences";
